export default {"src":"/_next/static/media/whatsapp-green.92cf427c.svg","height":120,"width":120};